//TODO : Refactor after ai
import { Fragment } from "react";
import type { HTMLAttributes, ReactNode } from "react";

export interface Crumb {
  label: string;
  icon?: ReactNode;
  onClick?: () => void;
}

export interface BreadcrumbsProps extends HTMLAttributes<HTMLElement> {
  items?: Crumb[];
}

const CHEVRON = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: "rotate(-90deg)" }}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);

/** Pfad; der letzte Eintrag ist die aktuelle Seite. */
export function Breadcrumbs({ items = [], className = "", ...rest }: BreadcrumbsProps) {
  return (
    <nav className={`bui-crumbs ${className}`} aria-label="Breadcrumb" {...rest}>
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <Fragment key={item.label}>
            <span
              data-crumb
              aria-current={last ? "page" : undefined}
              onClick={last ? undefined : item.onClick}
            >
              {item.icon}
              {item.label}
            </span>
            {!last && <span className="bui-crumbs__sep">{CHEVRON}</span>}
          </Fragment>
        );
      })}
    </nav>
  );
}
